import ViewEvent from "./ViewEvent";

export default ViewEvent